(function () {
    "use strict";

    // @ngInject
    function NetworkReferralItemDirectiveControllerFunc($scope, $state, $injector, $translate, $filter, NetworkManager, AnalyticsService, _,
                                                        CompanyService, moment, AppStates, UIUtils, Enums, $window, $timeout, PopupMessageService, OpportunityTypesService, DeviceService, ViewLoggingService, ModalService, ngToast) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkReferralItemDirectiveController';
        this.NetworkManager = NetworkManager;
        this.AnalyticsService = AnalyticsService;
        this._ = _;
        this.moment = moment;
        this.AppStates = AppStates;
        this.UIUtils = UIUtils;
        this.wasSeen = false;

        this.isShowOpportunityPopupBanner = false;
        this.likeText = '';

        this.$state = $state;
        this.CompanyService = CompanyService;
        this.vendorTypeTranslationMap = Enums.ExtendedCreativeTypesTranslationMap;
        this.activityObjectType = "network_referral";
        this.OppStatTypes = Enums.OpportunityStatusTypes;
        this.Enums = Enums;
        this.$window = $window;
        this.$timeout = $timeout;
        this.PopupMessageService = PopupMessageService;
        this.OpportunityTypesService = OpportunityTypesService;
        this.$filter = $filter;
        this.$translate = $translate;
        this.ViewLoggingService = ViewLoggingService;
        this.ModalService = ModalService;
        this.ngToast = ngToast;

        this.postOpportunityBannerTitle = "Now it’s your turn!";
        this.postOpportunityBannerText = "Consider posting an opportunity to help other creatives out."

        this.isShowingMoreText = false;
        this.maxShortTextLength = 200;
        this.isLikedAnimate = false;

        this.locationLabel = null;
        if (this.referral.dist_type === 'anywhere') {
            this.locationLabel = this.$translate.instant('NETWORK.OPPORTUNITIES._EVERYWHERE_');
        }
        else if (this.referral.location) {
            this.locationLabel = this.referral.location;
        }
        this.dropDownStartOpen = false;
        this.showMenuDisableReplying = false;

        if (this.showMenuDisableReplyingForId === this.referral._id) {
            this.showMenuDisableReplying = true;
            this.dropDownStartOpen = true;
        }

        this.warnHref = "";

        this.likers = [];
        this.showLikers = false;
        this.fetchingLikes = false;

        this.register(this.referral, 'success', this.referralUpdated.bind(this));
        if (this.canModerate()) {
            this.warnHref = this.warningEmailMailtoHref(this.referral);
        }
        this.referralUpdated();
        this.moderationFlags = this.referral.flagged_by_users;
        this.showFlaggers = false;

        this.socialShareCurrentState = (this.referral._id == this.justPostedOpportunityId);

        this.vendorTypesHighlighted = [];
        this.vendorTypes = [];
        this.isMobile = DeviceService.checkIfMobileSize();
        this.showSharingPopover = !this.isMobile && (this.referral._id == this.justPostedOpportunityId);

        this.setLikeButtonText();
        this.setViewesText();

        if (this.referral && this.referral.vendor_types) {
            this.referral.vendor_types.forEach(function (vendor_type) {
                if (this.subscribedVendorTypes && (this.subscribedVendorTypes.indexOf(vendor_type) > -1)) {
                    this.vendorTypesHighlighted.push(vendor_type);
                } else {
                    this.vendorTypes.push(vendor_type);
                }
            }.bind(this));
        }
    }

    var NetworkReferralItemDirectiveController = Class(Controllers.BaseController, {
        constructor: NetworkReferralItemDirectiveControllerFunc,

        setViewesText: function setViewesText() {
            switch (this.referral.uniq_views) {
                case 0:
                case null:
                    break;
                case 1:
                    this.viewsText = this.$translate.instant('FREQUENT_BUTTONS._VIEW_WITH_COUNTER_', {views: this.referral.uniq_views});
                    break;
                default:
                    this.viewsText = this.$translate.instant('FREQUENT_BUTTONS._VIEWS_WITH_COUNTER_', {views: this._formatViewsNumber(this.referral.uniq_views)});

            }

        },

        _formatViewsNumber: function _formatViewsNumber(viewsCount) {
            return this.UIUtils.formatRoundNumber(viewsCount, 1);
        },

        setLikeButtonText: function setLikeButtonText() {
            switch (this.referral.likes_count) {
                case 0:
                    this.likeText = this.$translate.instant('FREQUENT_BUTTONS._FIRST_LIKE_');
                    break;
                case 1:
                    this.likeText = this.$translate.instant('FREQUENT_BUTTONS._LIKE_WITH_COUNTER_', {likes: this.referral.likes_count});
                    break;
                default:
                    this.likeText = this.$translate.instant('FREQUENT_BUTTONS._LIKES_WITH_COUNTER_', {likes: this._formatViewsNumber(this.referral.likes_count)});

            }
        },

        toggleOpportunityPopupBanner: function toggleOpportunityPopupBanner() {
            this.isShowOpportunityPopupBanner = !this.isShowOpportunityPopupBanner;
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action,
                {
                    unique: this.Enums.CreateOpportunityOptionalSources.popup_banner_after_user_interaction,
                    page: 'opportunities_tab',
                    vendor_type: this.currUser.network.vendor_type,
                    is_shown: this.isShowOpportunityPopupBanner
                });
        },

        warningEmailMailtoHref: function warningEmailMailtoHref(referral) {
            var email = referral.author_email;
            var looking_for = referral.looking_for;
            var firstNameRaw = this.currUser.first_name;
            var first_name = firstNameRaw.charAt(0).toUpperCase() + firstNameRaw.slice(1);

            var lineBreak = "%0D%0A";

            var href = "mailto:" + email + "?subject=Warning: Your post, “" + looking_for + "”, violates our Creative Community guidelines&body=" +
                first_name + " from HoneyBook here - hope you’re doing well!" +
                lineBreak +
                lineBreak +
                "It looks like your recent post, “" + looking_for + "” violates our Creative Community guidelines and has been deleted." +
                lineBreak +
                lineBreak +
                "The Creative Community is a place where creatives like yourself can find and share job and collaboration opportunities. To maintain this focus, please refrain from posting any advertisement of products/services for which people will pay you." +
                lineBreak +
                lineBreak +
                "Instead, share any available jobs, referrals, and collaboration opportunities that you might have - we would love to hear about them!" +
                lineBreak +
                lineBreak +
                "We definitely think there’s a place and need for this type of post - we’re hard at work on building a separate area where folks will be encouraged to promote their services. Until then, I appreciate your understanding and patience!" +
                lineBreak +
                lineBreak +
                "To learn more about how to utilize the Creative Community, please see our community guidelines at:" + lineBreak +
                lineBreak +
                "https://intercom.help/honeybook-5891e2a409ff/community-and-opportunities/community-guidelines" +
                lineBreak +
                lineBreak +
                "Please let me know if you have any questions!" +
                lineBreak +
                lineBreak +
                "Thank you so much," +
                lineBreak +
                lineBreak +
                first_name +
                lineBreak +
                "HoneyBook Concierge";

            return href;
        },

        generateConciergeText: function generateConciergeText() {
            // var email = referral.author_email;
            // var looking_for = referral.looking_for;
            // var firstNameRaw = this.currUser.first_name;
            var referral = this.referral;

            this.NetworkManager.generateOpportunityConciergeEmail(referral).then(function gotFormHtml(resp) {
                var content =  resp.data.opportunity_concierge_email;
                if (!content){
                    content = "CANT CREATE CONCIERGE EMAIL TEXT";
                }
                var wnd = window.open("about:blank", "");
                wnd.document.write(content);
            }.bind(this));
        },

        getBudgetOutput: function getBudgetOutput(min_budget, max_budget) {
            var output = '';
            if (min_budget) {
                output = this.$filter('hbcurrency')(min_budget);
            }
            if (max_budget) {
                if (max_budget != min_budget) {
                    if (output) {
                        output = output.concat(' - ');
                    }
                    output = output.concat(this.$filter('hbcurrency')(max_budget));
                }
            }
            return output;
        },

        getOpportunityName: function getOpportunityName(key) {
            var opportunity_name;
            if (key && (opportunity_name = this.OpportunityTypesService.getOpportunityTypeName(key))) {
                return opportunity_name;
            }
            return 'Other'
        },

        gotoUserProfile: function gotoUserProfile(event, user_id) {
            event.stopPropagation();
            event.preventDefault();
            this.goToState(this.AppStates.root_network_profile, {user_id: user_id});
        },
        referralUpdated: function referralUpdated() {
            this.moderationFlags = this.referral.flagged_by_users;
        },

        getActivityTimestamp: function getActivityTimestamp() {
            var timeStampTxt = this.moment(this.referral.created_at).fromNow();
            ;
            return timeStampTxt;
        },

        getActivityUser: function getActivityUser() {
            if (this.referral.creator) {
                var user = this.referral.creator;
                if (user) {
                    return user.network;
                }
            } else {
                return this.referral.creator;
            }

            return null;
        },

        getUserById: function getUserById(id, users) {
            for (var i = 0; i < users.length; i++) {
                if (users[i]._id === id) {
                    return users[i];
                }
            }
            return null;
        },

        shortText: function shortText(text) {
            return this.UIUtils.concatenateString(text, this.maxShortTextLength);
        },

        hasMoreText: function hasMoreText(text) {
            if (text && text.length) {
                return this.shortText(text).length < text.length;
            } else {
                return false;
            }
        },

        shortenedText: function shortenedText(text) {
            return (this.hasMoreText(text) && !this.isShowingMoreText) ? this.shortText(text) : text;
        },

        showMoreText: function showMoreText() {
            this.isShowingMoreText = true;
        },

        getVendorTypeDisplayed: function getVendorTypeDisplayed(type) {
            return this.vendorTypeTranslationMap[type];
        },

        handleClickDisableReplying: function handleClickDisableReplying(event) {
            this.showMenuDisableReplying = true;
            event.stopPropagation();
        },

        updateStatus: function updateStatus(status) {
            this.referralData = {status: status};

            var oppId = this.referral ? this.referral._id : '';
            var oppAnalyticsSubproperties = status === this.OppStatTypes.active ?
                {
                    unique: 'enable_replies',
                    opportunityId: oppId
                } :
                {
                    unique: 'disable_replies',
                    opportunityId: oppId,
                    reason: status
                };
            this.AnalyticsService.track(this, 'success', oppAnalyticsSubproperties);

            this.update();
        },

        update: function update() {
            this.isSavingReferral = true;

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_edit_referral, this.referralData);

            if (this.referral._id) {
                this.NetworkManager.updateNetworkReferral(this.referral, this.referralData).then(
                    function success() {
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_edit_referral, {referralId: this.referral._id});
                    }.bind(this),
                    function error(resp) {
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_edit_referral, resp);
                        this.lastError = resp.data.error_message || resp.data;
                    }.bind(this))
                    .finally(function finallyHandler() {
                        this.isSavingReferral = false;
                        this.showMenuDisableReplying = false;
                    }.bind(this));
            }
        },

        doModerationWithMessage: function doModerationWithMessage(action, approvalAlertQuestion, approvalText) {

            var successCallback = function () {
                this.doModeration(action);
            }.bind(this);

            var cancelCallback = function () {
            };

            this.PopupMessageService.showConfirm(
                this.PopupMessageService.severityTypes.info,
                approvalAlertQuestion,
                successCallback,
                cancelCallback,
                approvalText,
                'Cancel'
            );
        },

        doModeration: function doModeration(action) {
            this.isSavingReferral = true;

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_moderate_referral, this.referralData);

            if (this.referral._id) {
                this.NetworkManager.moderateNetworkReferral(this.referral, action).then(
                    function success() {
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_edit_referral, {referralId: this.referral._id});
                    }.bind(this),
                    function error(resp) {
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_edit_referral, resp);
                        this.lastError = resp.data.error_message || resp.data;
                    }.bind(this))
                    .finally(function finallyHandler() {
                        this.isSavingReferral = false;
                        this.showMenuDisableReplying = false;
                    }.bind(this));
            }
        },

        isPaused: function isPaused() {
            return this.referral.status && this.referral.status !== this.OppStatTypes.active;
        },

        isBooked: function isBooked() {
            return this.referral.status &&
                (this.referral.status === this.OppStatTypes.bookedFromCommunity ||
                    this.referral.status === this.OppStatTypes.bookedFromOther);
        },

        canEdit: function canEdit() {
            return this.currUser._id === this.referral.creator._id;
        },

        canModerate: function canModerate() {
            return this.currUser.hasCommunityModeratorPermission();
        },

        resetMenu: function resetMenu() {
            this.showMenuDisableReplying = false;
        },

        handleClickReportOpportunity: function handleClickReportOpportunity() {
            this.AnalyticsService.track(this,
                this.AnalyticsService.analytics_events.action, {
                    unique: 'report_opp',
                    opportunityId: this.referral._id,
                    opportunityUrl: this.referral.public_referral_url,
                    opportunity_type: this.referral.opportunity_type
                }
            );

            this.showOpportunityReported = true;
            this.doModeration("flag");

            this.$timeout(function () {
                this.showOpportunityReported = false;
            }.bind(this), 3000);
        },

        showMenu: function showMenu() {
            return !this.showMenuDisableReplying;

        },

        getEmailTextForShareOpportunity: function handleClickShareOpportunityEmail() {
            var subject = "Opportunity near " + this.locationLabel + ": " + this.referral.looking_for.substr(0, 100);
            var body = "Hey, check out this business opportunity posted to " + this.locationLabel + ", I found on HoneyBook: " + this.referral.looking_for.substr(0, 100) + ", " + this.referral.public_referral_url;

            return {subject: subject, body: body};
        },

        handleClickModerationWarn: function handleClickModerationWarn(action) {
            var successCallback = function () {
                // this.doModeration(action);
            }.bind(this);

            var cancelCallback = function () {
            };

            this.PopupMessageService.showConfirm(
                this.PopupMessageService.severityTypes.info,
                'Not supported for now',
                successCallback,
                cancelCallback,
                'OK',
                'Cancel'
            );

        },

        handleClickModerationHide: function handleClickModerationHide(action) {
            this.doModerationWithMessage(action, 'Delete Opportunity from users feed?', 'Delete');
        },

        handleClickModerationApprove: function handleClickModerationApprove(action) {
            this.doModerationWithMessage(action, 'Approve Opportunity without notifications to users?', 'Approve for feed');
        },

        handleClickModerationApproveWithAlerts: function handleClickModerationApproveWithAlerts(action) {
            this.doModerationWithMessage(action, 'Approve Opportunity with notifications to users?', 'Approve');
        },

        handleClickModerationShowFlaggers: function handleClickModerationShowFlaggers() {
            this.showFlaggers = !this.showFlaggers;
        },

        canPerform: function canPerform(action) {
            return _.indexOf(this.referral.moderation_actions, action) >= 0;
        },

        postOpportunityFromPopupBanner: function postOpportunityFromPopupBanner() {
            this.isShowOpportunityPopupBanner = false;
            this.openCreateOpportunityModal({from_source: this.Enums.CreateOpportunityOptionalSources.popup_banner_after_user_interaction})
        },

        toggleLike: function toggleLike() {
            var action;
            if (this.referral.is_liked) {
                action = "unlike_opportunity";
                this.NetworkManager.unlikeOpportunity(this.referral).then(function success() {
                }.bind(this));
            } else {
                action = "like_opportunity";
                this.NetworkManager.likeOpportunity(this.referral).then(function success() {
                }.bind(this));
            }
            this.AnalyticsService.track(this, 'click', {
                unique: action,
                platform: 'web',
                source: 'network_referral_item',
                opportunity_type: this.referral.opportunity_type
            });

            this.isLikedAnimate = this.referral.is_liked = !this.referral.is_liked;

            this.referral.likes_count = (this.referral.likes_count || 0) + (this.referral.is_liked ? 1 : -1);
            this.setLikeButtonText();
        },

        hideLikers: function hideLikers() {
            this.showLikers = false;
        },

        handleLikeTextClick: function handleLikeTextClick() {
            if (this.referral.likes_count === 0) {
                this.toggleLike();
            } else {
                this.toggleLikers();
            }
        },

        _isSelfCommenting: function _isSelfCommenting() {
            return (this.referral.creator._id === this.currUser._id)
        },

        _isBannerAlreadyShownInCurrentSession: function _isBannerAlreadyShownInCurrentSession() {
            return Boolean(this.$window.sessionStorage.getItem('dont_show_popup_banner'))
        },

        onCommentSuccess: function onCommentSuccess() {

            if (!this._isBannerAlreadyShownInCurrentSession() && !this._isSelfCommenting()) {
                this.$timeout(function (_this) {
                    return function () {
                        switch (_this.currUser.network.vendor_type) {
                            case "photographer":
                                _this.postOpportunityBannerTitle = "Need a skilled second shooter?";
                                _this.postOpportunityBannerText = "Easily find a pro nearby who compliments your style.";
                                break;
                            case "event_planner":
                                _this.postOpportunityBannerTitle = "Planning a big event?";
                                _this.postOpportunityBannerText = "Make it memorable and get the best vendors in your area involved.";
                                break;
                        }

                        _this.toggleOpportunityPopupBanner();
                        _this.$window.sessionStorage.setItem('dont_show_popup_banner', true);
                    };
                }(this), 1000)

            }
        },

        toggleLikers: function toggleLikers() {
            this.showLikers = !this.showLikers;
            if (this.showLikers) {
                if (this.likers.length === 0) {
                    this.fetchingLikes = true;
                }
                this.NetworkManager.getOpportunityLikes(this.referral).then(function (users) {
                    this.likers = users;
                    this.fetchingLikes = false;
                }.bind(this)).catch(function () {
                    this.fetchingLikes = false;
                }.bind(this));
            }
        },

        isCreatorConnected: function isCreatorConnected() {
            return false;
        },

        inview: function inview(index, in_view, inviewpart) {
            if (!this.wasSeen && in_view) {
                this.wasSeen = true;
                this.ViewLoggingService.viewOpportunity(this.referral);
            }
        },

        handleClickEditOpportunity: function handleClickEditOpportunity() {
            this.openEditOpportunityModal();
        },

        openEditOpportunityModal: function openEditOpportunityModal() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action, {
                unique: 'edit_opp',
                opportunityId: this.referral._id
            });

            this.ModalService.openEditOpportunityModal({referral: this.referral})
                .then(function success(result) {
                    if (result) {
                        if (result.status === 'ok') {
                            this.$timeout(function () {
                                this.ngToast.create({
                                    content: 'Opportunity updated!',
                                    className: 'success',
                                    dismissOnTimeout: true,
                                    dismissButton: true
                                });
                            }.bind(this), 1000);
                        } else if (result.status === 'create_new') {
                            this.openCreateOpportunityModal({
                                from_source: this.Enums.CreateOpportunityOptionalSources.edit
                            });
                        }
                    }
                }.bind(this));
        },
    });

    function NetworkReferralItemDirective() {
        return {
            scope: {
                referral: "=",
                currUser: "=",
                subscribedVendorTypes: '=',
                justPostedOpportunityId: '=',
                persistenceKey: '=',
                banners: '=',
                showMenuDisableReplyingForId: '=',
                openCreateOpportunityModal: '&'
            },
            templateUrl: 'angular/app/modules/network/features/network_referral/network_referral_item_directive_template.html',
            controller: NetworkReferralItemDirectiveController,
            controllerAs: 'networkReferralItemVm',
            bindToController: true
        };
    };

    angular.module('honeybook.network.features.referral', [])
        .controller('NetworkReferralItemDirectiveController', NetworkReferralItemDirectiveController)
        .directive('hbNetworkReferralItem', NetworkReferralItemDirective);

}());
